/**
 * @generated SignedSource<<d384007e8a55e65f5ed7f7c08f7db6e2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Selectbox_selectBox$data = {
  readonly options: ReadonlyArray<{
    readonly data: string | null | undefined;
    readonly key: string | null | undefined;
    readonly label: string | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "Selectbox_selectBox";
};
export type Selectbox_selectBox$key = {
  readonly " $data"?: Selectbox_selectBox$data;
  readonly " $fragmentSpreads": FragmentRefs<"Selectbox_selectBox">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Selectbox_selectBox",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SelectBoxItem",
      "kind": "LinkedField",
      "name": "options",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "data",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SelectBox",
  "abstractKey": null
};

(node as any).hash = "544a2fe2e0dd65af1080cef005f041b1";

export default node;
